import React, { useCallback, useState } from "react";
// import styles from "./styles.css";
import PropTypes from "prop-types";
import { Button } from "@cars24/turbo-web/lib/button";
import RatingInput from "@cars24/turbo-web/lib/rating-input";
import LoginSignupV2 from "../login-signup-v2";
import { Text } from "@cars24/turbo-web/lib/text";
import { Input } from "@cars24/turbo-web/lib/input";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import styles from "./styles.css";
import { TextArea } from "@cars24/turbo-web/lib/text-field";
// import UploadFile from "./images/upload-file.svg";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import FeedBackDoneIcon from "./images/feedback-done.svg";
import nameValidator from "../../../utils/validators/name-validator";

const ReviewForm = ({
    isLoggedIn,
    secureToken,
    saveCustomerReviewConnect,
    name
}) => {
    const { tokens } = useTokens();
    const [rating, setRating] = useState(0);
    const [review, setReview] = useState("");
    const [isBtnLoading, setIsBtnLoading] = useState(false);
    const [userName, setUserName] = useState(name || "");
    const [isSuccess, setIsSuccess] = useState(false);
    const [headline, setHeadline] = useState("");

    const handleSubmit = useCallback(async() => {
        await yieldToMain();
        setIsBtnLoading(true);
        const payload = {
            "review_description": review,
            "review_rating": rating,
            "customer_name": userName,
            "title": headline
        };
        saveCustomerReviewConnect(payload, secureToken).then(() => {
            setIsSuccess(true);
            setIsBtnLoading(false);
        }).catch(() => {
            setIsBtnLoading(false);
        });
    }, [headline, rating, review, saveCustomerReviewConnect, secureToken, userName]);

    if (!isLoggedIn) {
        return (
            <LoginSignupV2
                isNative
                isVisible
            />
        );
    }

    if (isSuccess) {
        return (
            <div styleName={"styles.feedbackSubmit"}>
                <img src={FeedBackDoneIcon} alt="done icon" width="114px" height="116px" />
                <Text
                    align="center"
                    as="p"
                    fontWeight="semibold"
                    size="400"
                    transform="none"
                    color={tokens.text_default_text_primary}
                >
                    Thanks for your feedback!
                </Text>
                <Text
                    align="center"
                    as="p"
                    fontWeight="regular"
                    size="300"
                    transform="none"
                    color={tokens.text_default_text_secondary}
                >
                    Your feedback has been recorded and will help<br />shape better experiences for everyone.
                </Text>
            </div>
        );
    }

    return (
        <div styleName={"styles.reviewForm"}>
            <div styleName={"styles.heading"}>
                <Text
                    align="left"
                    as="p"
                    fontWeight="semibold"
                    size="450"
                    transform="none"
                    color={tokens.text_default_text_primary}
                >
                Reviews & Ratings
                </Text>
            </div>
            <div styleName={"styles.rattingWrapper"}>
                <div styleName={"styles.rattingCard"}>
                    <Text
                        align="left"
                        as="p"
                        fontWeight="medium"
                        size="350"
                        transform="none"
                        color={tokens.text_default_text_primary}
                    >
                    Overall rating
                    </Text>
                    <RatingInput
                        onChange={(value) => setRating(value)}
                        size="medium"
                        value={rating}
                        max={5}
                    />
                </div>

                <div styleName={"styles.rattingCard"}>
                    <Text
                        align="left"
                        as="p"
                        fontWeight="medium"
                        size="350"
                        transform="none"
                        color={tokens.text_default_text_primary}
                    >
                        Name
                        <Text
                            align="left"
                            as="span"
                            fontWeight="medium"
                            size="350"
                            transform="none"
                            color="#B4272E"
                        >*</Text>
                    </Text>
                    <Input
                        customErrorMessage=""
                        hint=""
                        onChange={(e) => setUserName(e.target.value)}
                        placeholder="Enter your name"
                        type="text"
                        validator={nameValidator}
                        value={userName}
                    />
                </div>

                <div styleName={"styles.rattingCard"}>
                    <Text
                        align="left"
                        as="p"
                        fontWeight="medium"
                        size="350"
                        transform="none"
                        color={tokens.text_default_text_primary}
                    >
                        Add headline
                        <Text
                            align="left"
                            as="span"
                            fontWeight="medium"
                            size="350"
                            transform="none"
                            color="#B4272E"
                        >*</Text>
                    </Text>
                    <Input
                        customErrorMessage=""
                        hint=""
                        onChange={(e) => setHeadline(e.target.value)}
                        placeholder="Add headline"
                        type="text"
                        validator={() => {}}
                        value={headline}
                    />
                </div>

                <div styleName={"styles.rattingCard"}>
                    <Text
                        align="left"
                        as="p"
                        fontWeight="medium"
                        size="350"
                        transform="none"
                        color={tokens.text_default_text_primary}
                    >
                        Add a review
                        <Text
                            align="left"
                            as="span"
                            fontWeight="medium"
                            size="350"
                            transform="none"
                            color="#B4272E"
                        >*</Text>
                    </Text>
                    <TextArea
                        label=""
                        value={review}
                        charLength={2000}
                        onChange={(e) => setReview(e.target.value)}
                        placeholder="Add a review"
                    />
                </div>

                {/* <div styleName={"styles.rattingCard"}>
                    <Text
                        align="left"
                        as="p"
                        fontWeight="medium"
                        size="350"
                        transform="none"
                        color={tokens.text_default_text_primary}
                    >
                        Add a photo
                    </Text>
                    <label styleName={"styles.uploadFile"}>
                        <input type="file" />
                        <img src={UploadFile} alt="upload" />
                    </label>
                </div>*/}
            </div>

            <div styleName={"styles.reviewSubmitForm"}>
                <Button
                    disabled={!(
                        rating &&
                        review &&
                        headline &&
                        userName?.trim() &&
                        nameValidator(userName)
                    )}
                    variant="primary"
                    size="large"
                    type="button"
                    label={"Submit review"}
                    loading={isBtnLoading} onClick={handleSubmit} />
            </div>
        </div>
    );
};

ReviewForm.propTypes = {
    isLoggedIn: PropTypes.bool,
    secureToken: PropTypes.string,
    saveCustomerReviewConnect: PropTypes.func,
    name: PropTypes.string
};

export default ReviewForm;
